import { useLocation } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '/dashboard': 'Command Dashboard', '/clients': 'Clients', '/client': 'Client Profile',
  '/vendors': 'Vendors', '/accounts': 'All Accounts', '/customers': 'Customer CRM', '/catalog': 'Materials & Dies', '/aliases': 'Confirm the spelling',
  '/intake': 'Intake & Requests', '/requests': 'Request Log', '/prepress': 'Prepress Workspace', '/tasks': 'Task Board', '/calendar': 'Shared Calendar',
  '/web-leads': 'Web Leads', '/pipeline': 'Opportunity Pipeline', '/quote-builder': 'Quote Builder', '/quote-engine': 'Quote Engine', '/quotes': 'Quote Registry',
  '/follow-ups': 'Follow-Ups', '/reorders': 'Reorder Intelligence', '/comms-log': 'Communication Log',
  '/sales-calendar': 'Sales Calendar', '/sales-ai': 'AI Sales Assistant',
  '/ai': 'AI Command Room', '/manual': 'Operating Manual', '/kpis': 'KPI Dashboard',
  '/roadmap': 'Implementation Roadmap', '/architecture': 'Architecture', '/audit': 'Sync + Audit Log',
};

export default function Topbar({ onSearch }: { onSearch: () => void }) {
  const loc = useLocation();
  const title = TITLES[loc.pathname] || 'Staff Backend';
  const date = new Date().toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  return (
    <header className="topbar">
      <div className="crumbs"><span>MFX OS</span><span className="sep">/</span><strong>{title}</strong></div>
      <button className="searchbar" onClick={onSearch}>
        <span className="searchbar-ico">⌕</span>
        <span className="searchbar-txt">Search clients, pages…</span>
        <kbd>⌘K</kbd>
      </button>
      <div className="topbar-right"><span className="topbar-date">{date}</span></div>
    </header>
  );
}
